import React, { useState } from "react";
import { Form, Row, Col, Button, Card, Badge } from "react-bootstrap";
import { IconPlus, IconTrash } from "@tabler/icons-react";

const AdvancedConditions = ({ conditions, onChange }) => {
  const [localConditions, setLocalConditions] = useState(conditions || []);

  const handleAddCondition = () => {
    const newCondition = {
      id: Date.now(),
      field: "client_type",
      operator: "equals",
      value: "",
    };
    const updatedConditions = [...localConditions, newCondition];
    setLocalConditions(updatedConditions);
    onChange && onChange(updatedConditions);
  };

  const handleRemoveCondition = (id) => {
    const updatedConditions = localConditions.filter(
      (condition) => condition.id !== id
    );
    setLocalConditions(updatedConditions);
    onChange && onChange(updatedConditions);
  };

  const handleConditionChange = (id, field, value) => {
    const updatedConditions = localConditions.map((condition) => {
      if (condition.id === id) {
        return { ...condition, [field]: value };
      }
      return condition;
    });
    setLocalConditions(updatedConditions);
    onChange && onChange(updatedConditions);
  };

  const getFieldOptions = () => {
    return [
      { value: "client_type", label: "Tipo de Cliente" },
      { value: "service_type", label: "Tipo de Serviço" },
      { value: "appointment_duration", label: "Duração da Consulta" },
      { value: "is_new_client", label: "Novo Cliente" },
      { value: "insurance", label: "Convênio" },
    ];
  };

  const getOperatorOptions = (fieldType) => {
    const commonOperators = [
      { value: "equals", label: "Igual a" },
      { value: "not_equals", label: "Diferente de" },
    ];

    const numericOperators = [
      ...commonOperators,
      { value: "greater_than", label: "Maior que" },
      { value: "less_than", label: "Menor que" },
    ];

    const booleanOperators = [{ value: "equals", label: "É" }];

    switch (fieldType) {
      case "appointment_duration":
        return numericOperators;
      case "is_new_client":
        return booleanOperators;
      default:
        return commonOperators;
    }
  };

  const getValueInput = (condition) => {
    const fieldType = condition.field;

    switch (fieldType) {
      case "client_type":
        return (
          <Form.Select
            value={condition.value}
            onChange={(e) =>
              handleConditionChange(condition.id, "value", e.target.value)
            }
          >
            <option value="">Selecione...</option>
            <option value="regular">Regular</option>
            <option value="vip">VIP</option>
            <option value="new">Novo</option>
          </Form.Select>
        );
      case "service_type":
        return (
          <Form.Select
            value={condition.value}
            onChange={(e) =>
              handleConditionChange(condition.id, "value", e.target.value)
            }
          >
            <option value="">Selecione...</option>
            <option value="consultation">Consulta</option>
            <option value="exam">Exame</option>
            <option value="procedure">Procedimento</option>
          </Form.Select>
        );
      case "appointment_duration":
        return (
          <Form.Control
            type="number"
            value={condition.value}
            onChange={(e) =>
              handleConditionChange(condition.id, "value", e.target.value)
            }
            placeholder="Duração em minutos"
          />
        );
      case "is_new_client":
        return (
          <Form.Select
            value={condition.value}
            onChange={(e) =>
              handleConditionChange(condition.id, "value", e.target.value)
            }
          >
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </Form.Select>
        );
      case "insurance":
        return (
          <Form.Control
            type="text"
            value={condition.value}
            onChange={(e) =>
              handleConditionChange(condition.id, "value", e.target.value)
            }
            placeholder="Nome do convênio"
          />
        );
      default:
        return (
          <Form.Control
            type="text"
            value={condition.value}
            onChange={(e) =>
              handleConditionChange(condition.id, "value", e.target.value)
            }
            placeholder="Valor"
          />
        );
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <h6 className="mb-0">Condições Avançadas</h6>
      </Card.Header>
      <Card.Body>
        {localConditions.length === 0 ? (
          <p className="text-muted mb-3">
            Sem condições. A mensagem será enviada para todos os clientes.
          </p>
        ) : (
          localConditions.map((condition, index) => (
            <Row key={condition.id} className="mb-3 align-items-end">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Campo</Form.Label>
                  <Form.Select
                    value={condition.field}
                    onChange={(e) =>
                      handleConditionChange(
                        condition.id,
                        "field",
                        e.target.value
                      )
                    }
                  >
                    {getFieldOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Operador</Form.Label>
                  <Form.Select
                    value={condition.operator}
                    onChange={(e) =>
                      handleConditionChange(
                        condition.id,
                        "operator",
                        e.target.value
                      )
                    }
                  >
                    {getOperatorOptions(condition.field).map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Valor</Form.Label>
                  {getValueInput(condition)}
                </Form.Group>
              </Col>
              <Col md={1}>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleRemoveCondition(condition.id)}
                >
                  <IconTrash size={16} />
                </Button>
              </Col>
              {index < localConditions.length - 1 && (
                <Col md={12} className="mt-2 mb-2">
                  <div className="border-bottom w-100"></div>
                  <div className="text-center mt-2 mb-2">
                    <Badge bg="secondary">E</Badge>
                  </div>
                </Col>
              )}
            </Row>
          ))
        )}
        <div className="text-center mt-3">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleAddCondition}
            className="d-flex align-items-center mx-auto"
          >
            <IconPlus size={16} className="me-1" />
            Adicionar Condição
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AdvancedConditions;
